import React, { FC, useContext, useState } from 'react';
import moment                              from 'moment';
import { Header, Icon, List }              from 'semantic-ui-react';
import classNames                          from 'classnames';
import { Cell, Grid }                      from "styled-css-grid";

import { capitalize }                                                      from '../../../../../util';
import { TimeService, UserService }                                        from '../../../../../services';
import { CorvalProject, CorvalUIColor, CorvalUserLike, Size, SystemEvent } from '../../../../../types';
import { StyledContainer }                                                 from '../../../../containers';
import { OrganizationUser }                                                from '../../../../components/user/OrganizationUser';
import { ProjectListContext }                                              from './ProjectListIndexPage';

interface Props {
    item: Partial<CorvalProject>,

    onClick?( e: SystemEvent ): void,
}

const defaultProps: Props = {
    item:    null,
    onClick: null,
}

const ProjectListItem: FC<Props> = ( props ) => {

    let { focusedProjectId } = useContext( ProjectListContext ),
        { item }             = props;

    let createdTimestamp          = TimeService.ISOtoDisplayDate( item.createdUtc, true ),
        createdTimestampFormatted = TimeService.ISOtoFormat( item.createdUtc, undefined, true ),
        updatedTimestampFormatted = TimeService.ISOtoFormat( item.createdUtc, undefined, true ),
        humanizedUpdateTimstamp   = TimeService.getHumanizedDays( item.updatedUtc, moment(), true, false, 'seconds' );

    let useUpdatedTimestamp = moment( updatedTimestampFormatted ).isAfter( createdTimestampFormatted ),  // Note: updated might be null, so convert to a moment just in case
        isFocused           = ( focusedProjectId === item.id );

    let descriptorLanguage = {
        action:    useUpdatedTimestamp ? 'Updated' : ' Created',
        timestamp: useUpdatedTimestamp ? humanizedUpdateTimstamp : createdTimestamp,
        userId:    useUpdatedTimestamp ? item.updatedById : item.createdById,
    }

    return (

            <List.Item onClick={ props.onClick } id={ item.id } className={ classNames( {
                'opacity--100':       isFocused,
                'opacity--85':        !isFocused,
                'opacity-hover--100': true,
            } ) }>

                <StyledContainer
                        padding={ [ Size.SM, Size.MD ] }
                        textColor={ CorvalUIColor.WHITE }
                        className={ classNames( 'cursor--pointer outline--colored-teal outline-md', { 'outline--hover': !isFocused } ) }>

                    <Grid columns={ `auto 1fr auto` } rows={ `auto auto` } rowGap={ '6px' } columnGap={ '20px' }>

                        <Cell height={ 1 } left={ 1 } top={ 1 }>

                            <Icon name={ 'briefcase' } color={ 'teal' } fitted style={ { transform: `translateY(1px)` } }/>

                        </Cell>
                        <Cell left={ 2 } top={ 1 }>

                            <Header as={ 'h4' } color={ 'red' } className={ 'text-capitalize' }>{ item.name }</Header>

                        </Cell>
                        <Cell left={ 2 } top={ 2 }>

                            <List className={ 'no-padding' }>

                                <List.Item>
                                    <strong className={ 'text--colored-lt-screen-50' }>{ descriptorLanguage.action }:</strong>{ ' ' }

                                    { descriptorLanguage.timestamp }

                                    <OrganizationUser
                                            organizationId={ item.organizationId }
                                            accountId={ descriptorLanguage.userId }
                                            className={ 'display--inline-block' }>

                                        { ( user: CorvalUserLike ) => (
                                                <span>
											<span className={ 'text--colored-lt-screen-50' }>&nbsp;by&nbsp;</span>
                                                    { UserService.getUserName( user ) }
										</span>
                                        ) }

                                    </OrganizationUser>
                                </List.Item>

                            </List>

                        </Cell>
                        <Cell height={ 2 } left={ 3 } top={ 1 } middle center>

                            <Icon name={ 'chevron right' } color={ 'teal' }/>

                        </Cell>
                    </Grid>

                </StyledContainer>

            </List.Item>

    )
};

ProjectListItem.defaultProps = defaultProps;

export { ProjectListItem }
